function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgHelpbook(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M44.205 3.36l-20.297.042c-4.531-.061-8.067 1.188-10.632 3.716-3.296 3.25-3.651 7.409-3.651 9.046V79.64c0 7.168 5.631 13 12.553 13H85.25V3.36H44.205zm2.628 7.994l13.315-.028v25.309l-4.731-4.339a2.998 2.998 0 00-4.053-.002l-4.531 4.148V11.354zM77.25 84.64H22.178c-2.511 0-4.553-2.243-4.553-5s2.042-5 4.553-5H77.25v10zm0-18H22.178c-1.607 0-3.139.326-4.553.898V16.164c0-.351.062-2.159 1.269-3.349.983-.97 2.655-1.443 4.966-1.413l16.974-.035v31.89a3 3 0 005.025 2.213l7.529-6.893 7.733 7.093a2.996 2.996 0 003.235.535 3 3 0 001.792-2.746V11.314l11.102-.023V66.64z"
  }));
}

SvgHelpbook.clsName = 'icon-www__helpbook';
SvgHelpbook.remarkName = 'unknown';
export default SvgHelpbook;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Helpbook.js
// module id = 2357
// module chunks = 17 18